import { create } from "zustand";
import { persist } from "zustand/middleware";

export type BreadcrumbItem = {
  title: string;
  href?: string;
  icon?: React.ReactNode;
};

type BreadcrumbState = {
  items: BreadcrumbItem[];
  isLoading: boolean;
  isCustomBreadcrumb: boolean;
  setBreadcrumbs: (items: BreadcrumbItem[]) => void;
  setLoading: (isLoading: boolean) => void;
  setCustomBreadcrumb: (isCustom: boolean) => void;
  clearBreadcrumbs: () => void;
};

export const useBreadcrumbStore = create<BreadcrumbState>()(
  persist(
    (set) => ({
      items: [],
      isLoading: false,
      isCustomBreadcrumb: false,
      setBreadcrumbs: (items) => set({ items, isLoading: false, isCustomBreadcrumb: true }),
      setLoading: (isLoading) => set({ isLoading }),
      setCustomBreadcrumb: (isCustom) => set({ isCustomBreadcrumb: isCustom }),
      clearBreadcrumbs: () => set({ items: [], isLoading: false, isCustomBreadcrumb: false }),
    }),
    {
      name: "breadcrumb-store",
      partialize: (state) => ({
        items: state.items.map(({ title, href }) => ({ title, href })),
        isCustomBreadcrumb: state.isCustomBreadcrumb,
      }),
    },
  ),
);
